import React from "react";

const PageNotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.errorText}>404 Error</h1>
      <h2 style={styles.subText}>Page Not Found</h2>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100%",
    padding: "var(--space-8)",
    textAlign: "center",
    backgroundColor: "var(--surface-page)",
  },
  errorText: {
    fontSize: "var(--fs-2xl)",
    fontWeight: "var(--fw-bold)",
    color: "var(--text-strong)",
  },
  subText: {
    fontSize: "var(--fs-lg)",
    fontWeight: "var(--fw-regular)",
    color: "var(--text-muted)",
  },
};

export default PageNotFound;
